import React from 'react';
import { Formik } from 'formik';
import { TextField, Button, Link } from '@material-ui/core';
import * as Yup from 'yup';

import * as Styled from './Login.styled';
import logo from '../assets/logo';
import { usePasswordRecover, PasswordRecoverRequest } from '../user/User.hooks';
import { useRemoveJiraWidget } from '../common/useRemoveJiraWidget';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid e-mail address.')
    .required('E-mail address is required.')
});

export const PasswordRecover: React.FC = () => {
  useRemoveJiraWidget();
  const { success, isLoading, error, doPasswordRecover } = usePasswordRecover();
  let errorMessage = error
    ? 'Unable to send reset password. Please double check your credentials.'
    : undefined;

  const handleSubmit = (form: PasswordRecoverRequest) => {
    errorMessage = undefined;
    doPasswordRecover(form.email);
  };

  return (
    <Styled.StyledLoginContainer>
      <Styled.StyledLoginCard>
        <img src={logo} alt='Sierra Labs' className='logo' />
        <h2 style={success ? { marginBottom: '18px' } : {}}>
          {success ? 'Check your Email' : 'Password Recover'}
        </h2>

        {!success && (
          <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            validateOnBlur={true}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Styled.StyledLoginForm>
                <TextField
                  variant='outlined'
                  type='email'
                  name='email'
                  label='Email'
                  className='form-field'
                  placeholder='Specify your email to reset'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={isLoading}
                  value={values.email}
                  error={touched.email && !!errors.email}
                  helperText={errors.email}
                />

                {!isLoading && error && <p className='error'>{errorMessage}</p>}

                <Button
                  type='submit'
                  variant='contained'
                  disableElevation
                  disabled={isLoading}
                >
                  Reset via Email
                </Button>
              </Styled.StyledLoginForm>
            )}
          </Formik>
        )}

        {success && (
          <Styled.StyledLoginCardContent>
            We've sent you an email. Click the link in the email to reset your
            password.
          </Styled.StyledLoginCardContent>
        )}

        <Link className='forgot-password-link' href='/login'>
          Back to Login
        </Link>
      </Styled.StyledLoginCard>
    </Styled.StyledLoginContainer>
  );
};

export default PasswordRecover;
